import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Shell, Field } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      setSent(true); // never reveal whether the email exists
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <Shell title="Check your email" subtitle="If an account exists for that address, we've sent a password reset link. It expires in 1 hour.">
        <p className="text-sm text-[var(--ink-soft)]">Didn't get it? Check spam, or <button onClick={() => setSent(false)} className="font-semibold text-[var(--brand)]">try again</button>.</p>
        <p className="mt-6 text-center text-sm text-[var(--ink-soft)]"><Link to="/login" className="font-semibold text-[var(--brand)]">Back to log in</Link></p>
      </Shell>
    );
  }

  return (
    <Shell title="Reset your password" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit}>
        <Field label="Work email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
        <button type="submit" disabled={loading} data-testid="forgot-submit"
          className="w-full rounded-full bg-[var(--brand)] py-3 text-sm font-semibold text-white transition-colors hover:bg-[var(--brand-dark)] disabled:opacity-60">
          {loading ? "Sending…" : "Send reset link"}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-[var(--ink-soft)]"><Link to="/login" className="font-semibold text-[var(--brand)]">Back to log in</Link></p>
    </Shell>
  );
}
